import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	longRequestCreateTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.modal-flags.long-request-create-title',
		defaultMessage: "We're adding your priority scheme",
		description:
			'Flag title that is shown after a new priority scheme has been created by a user but not yet finalised or accessible',
	},
	longRequestEditTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.modal-flags.long-request-edit-title',
		defaultMessage: "We're updating your priority scheme",
		description:
			'Flag title that is shown after a new priority scheme has been edited by a user but not yet finalised or accessible',
	},
	longRequestDescription: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.modal-flags.long-request-description',
		defaultMessage: 'This may take a while. You can edit schemes when this is completed.',
		description:
			'Flag description that is shown after a user has created or edited a priority scheme but not yet finalised or accessible',
	},
	createdSchemeTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.modal-flags.created-scheme-title',
		defaultMessage: 'Priority scheme {name} added',
		description: 'Flag title shown after a user has successfully created a new priority scheme',
	},
	editedSchemeTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.modal-flags.edited-scheme-title',
		defaultMessage: 'Priority scheme updated',
		description:
			'Flag title shown after a user has successfully edited an existing priority scheme',
	},
	editedSchemeDescription: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.modal-flags.edited-scheme-description',
		defaultMessage: 'We’ve updated the priority scheme "{name}"',
		description: 'Flag description shown after a use has successfully edited a new priority scheme',
	},
	successIconLabel: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.modal-flags.success-icon-label',
		defaultMessage: 'Success',
		description:
			'Icon label for a green tick icon that shows a success case of either adding or editing a priority scheme',
	},
	unexpectedCreateErrorTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.modal-flags.unexpected-create-error-title',
		defaultMessage: "We couldn't add the scheme",
		description:
			'Error heading when there is an unknown failure when creating a new priority scheme',
	},
	unexpectedEditErrorTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.modal-flags.unexpected-edit-error-title',
		defaultMessage: "We couldn't update the scheme",
		description:
			'Error heading when there is an unknown failure when updating an exiting priority scheme',
	},
	unexpectedErrorBodyMessage: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.modal-flags.unexpected-error-body-message',
		defaultMessage: 'Refresh the page and try again.',
		description:
			'Error body message when there is an unknown failure when creating or updating a priority scheme',
	},
	viewPrioritySchemesAction: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.modal-flags.view-priority-schemes-action',
		defaultMessage: 'View priority scheme',
		description: 'Action link to view newly added or edited priority scheme',
	},
});

export default messages;
